import { lightMaterialTheme } from '@zz2/zz2-ui';

const defaultTheme = lightMaterialTheme;

export default defaultTheme;
